import _ from 'lodash'
import moment from 'moment'
import axios from 'axios'
import { RootState } from '@/store/types';
import { Waiting, WaitingConditions, WaitingState } from '@/store/waitings/types'
import { Commit, ActionTree } from 'vuex';

const actions: ActionTree<WaitingState, RootState> = {
  fetchWaitings: async (
    { commit }: {commit: Commit},
    conditions : WaitingConditions,
  ) => {
    const response = await axios.get('/waitings', {
      params: _.pickBy({
        date: conditions.date?.format('YYYYMMDD'),
        period: conditions.period,
      }),
    })

    const { data } = response
    const waitings: Waiting[] = data.map((waiting: any): Waiting => ({
      tutor: {
        id: waiting.tutorId,
        name: waiting.tutorName,
      },
      substituteCount: waiting.substituteCount,
      latestSubstituteDate:
        (waiting.latestSubstituteDate && moment(waiting.latestSubstituteDate, 'YYYYMMDD')) || null,
      campusName: waiting.campusName,
      waitingPriority: waiting.waitingPriority,
    }))

    commit('fetchedWaitings', waitings);
  },
};

export default actions;
